module.exports = __webpack_public_path__ + "static/media/imgClient.adbceb19.svg";